module.exports = __webpack_public_path__ + "assets/tiyu.20068b4b.svg";